export function createEditor(options) {
    return unlayer.createEditor(options);
}
